<script setup lang="ts">
import { storeToRefs } from 'pinia';
import AlertPopup from '@/dashboard/vue/popups/AlertPopup.vue';
import { useAlertStore } from '@/dashboard/store/alertStore';

const alertStore = useAlertStore();
const { isOpen, title, subtitle, okTitle, cancelTitle, cancelAction } = storeToRefs(alertStore);
</script>

<template>
  <AlertPopup
    :title="title ?? ''"
    :subtitle="subtitle ?? ''"
    :show="isOpen"
    :ok-title="okTitle"
    :cancel-title="cancelTitle"
    :cancel="cancelAction ? alertStore.cancel : undefined"
    :ok="alertStore.confirm"
  />
</template>
